export default {
	layout_: state => {
		return state.widgetItems;
	},
	getWidget_: state => widgetTitle => {
		return state.dynamicComp[widgetTitle];
	},
	showCoachMark_(state, getters) {
		return _.isEmpty(getters.layout_) && state.displayCoachMarkFlag;
	}
};
